import {
  color
} from "./chunk-KBRIPOOD.js";

// src/theme/paletteExtended.ts
var paletteExtended = {
  background: {
    dark: color.B10
  },
  link: {
    default: color.B6.hex,
    contrast: color.B3.hex
  }
};

export {
  paletteExtended
};
//# sourceMappingURL=chunk-GP7ZEBHS.js.map